import { render, staticRenderFns } from "./SimpleHorizontalLayout.vue?vue&type=template&id=c0a65084&scoped=true&"
import script from "./SimpleHorizontalLayout.vue?vue&type=script&lang=js&"
export * from "./SimpleHorizontalLayout.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHorizontalLayout.vue?vue&type=style&index=0&id=c0a65084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a65084",
  null
  
)

export default component.exports